import React, { FC } from 'react'

import clsx from 'clsx'

import { getRankClasses } from '../../../../../helpers/helpers'

import TogglesElement from '../../../../elements/toggles/toggles/TogglesElement'

import {
  IScoreCardInterface,
  IScoreCardSection,
} from '../../../../../models/score-cards/score-cards.interface'
import { UseFormSetValue, UseFormWatch } from 'react-hook-form/dist/types/form'
import { IRegistrationByDayInterface } from '../../../../../models/registrations-by-day/registrationByDay.interface'

interface CustomScoringModalHeaderProps {
  sections: IScoreCardSection[]
  watch: UseFormWatch<IScoreCardInterface>
  setValue: UseFormSetValue<IScoreCardInterface>
  editable: boolean
  rider: IRegistrationByDayInterface
  type?: 'event-results'
}
export const CustomScoringModalHeader: FC<CustomScoringModalHeaderProps> = ({
  sections,
  watch,
  setValue,
  editable,
  rider,
  type,
}) => {
  return (
    <div className="pb-6 mb-6 border-b border-b-SeabiscuitLightThemeColorD3">
      <div className="flex items-center justify-between gap-2 mb-5">
        <h4 className="font-bold text-lg md:text-[25px]">{watch('name')}</h4>
        {type !== 'event-results' && (
          <div
            className={clsx(
              'flex items-center gap-2 text-[14px] whitespace-nowrap',
              !!watch('isWithdrew') && 'text-SeabiscuitDark200ThemeColor/50'
            )}
          >
            Withdrew?
            <TogglesElement
              buttonClassName="small"
              checkedMessage=""
              uncheckedMessage=""
              on={watch('isWithdrew')}
              onToggle={() => editable && setValue(`isWithdrew`, !watch(`isWithdrew`))}
            />
          </div>
        )}
      </div>
      <div className="flex gap-3 justify-between">
        <div
          className={clsx(
            'flex items-center justify-center p-2 w-[56px] bg-SeabiscuitGrayThemeColor rounded-md font-bold',
            getRankClasses({ rank: rider.score?.rank, totalPoints: rider.score?.totalPoints })
          )}
        >
          {rider?.score?.rank || 0}
        </div>
        <div className="flex-1 flex flex-col gap-2.5">
          {watch('isWithdrew') ? (
            <div className="flex flex-wrap gap-1 items-center justify-end px-4 py-2 w-full bg-SeabiscuitGrayThemeColor rounded-md">
              <div className="whitespace-nowrap flex justify-between gap-2 md:gap-5 items-center">
                <p className="rounded-full py-2 px-4 bg-white">Withdrew</p>
              </div>
            </div>
          ) : (
            sections?.map((section) => {
              const showSection = section.type !== 'jump off' || watch('showJumpOff')
              return (
                showSection &&
                !watch('isWithdrew') && (
                  <div
                    key={section.id}
                    className="flex flex-wrap gap-1 items-center justify-between px-4 py-2 w-full bg-SeabiscuitGrayThemeColor rounded-md"
                  >
                    {section.name}
                    <div className="whitespace-nowrap flex justify-between gap-2 md:gap-5 items-center">
                      <p>{section.totalFaultsStatus || `${section.totalTime} seconds`}</p>
                      <p className="rounded-full py-2 px-4 bg-white">
                        {section.totalFaultsCount ?? 0}F / {section.totalTimeFaults ?? 0}TF
                      </p>
                    </div>
                  </div>
                )
              )
            })
          )}
        </div>
      </div>
    </div>
  )
}
